// @ts-nocheck


import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { createFaq } from "../../../features/faq";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AddFaq = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    status: "Draft", // Default status
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    console.log(formData, "formData");
    // Replace `createFaq` with your appropriate Redux action
        //  @ts-ignore 

    dispatch(createFaq(formData))
        //  @ts-ignore 

      .then((res) => {
        //  @ts-ignore 

        const notify = () => toast.success(res.payload.message);
        notify();
        navigate('/faq')
        console.log(res, "response");
      })
        //  @ts-ignore 

      .catch((err) => {
        console.log(err, "error");
      });
  };

  return (
        //  @ts-ignore 

    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
        {/* @ts-ignore  */}

      <SoftBox width="100%" maxWidth="400px">
      {/* @ts-ignore  */}

        <SoftBox mb={2}>
     {/* @ts-ignore  */}

          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add FAQ
          </SoftTypography>
        </SoftBox>
         {/* @ts-ignore  */}

        <SoftBox component="form" role="form">
          {/* Question Input */}
        {/* @ts-ignore  */}

          <SoftBox mb={2}>
        {/* @ts-ignore  */}

            <SoftBox mb={1} ml={0.5}>
         {/* @ts-ignore  */}

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Question
              </SoftTypography>
            </SoftBox>
            <SoftInput
        //  @ts-ignore 

              type="text"
              name="question"
              placeholder="Enter the question"
              value={formData.question}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Answer Input */}
         {/* @ts-ignore  */}

          <SoftBox mb={2}>
        {/* @ts-ignore  */}

            <SoftBox mb={1} ml={0.5}>
       {/* @ts-ignore  */}

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Answer
              </SoftTypography>
            </SoftBox>
            <SoftInput
        //  @ts-ignore 

              type="text"
              name="answer"
              placeholder="Enter the answer"
              value={formData.answer}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Status Dropdown */}
         {/* @ts-ignore  */}

          <SoftBox mb={2}>
         {/* @ts-ignore  */}

            <SoftBox mb={1} ml={0.5}>
         {/* @ts-ignore  */}

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Status
              </SoftTypography>
            </SoftBox>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="Draft">Draft</option>
              <option value="Published">Published</option>
            </select>
          </SoftBox>

          {/* Submit Button */}
      {/* @ts-ignore  */}

          <SoftBox mt={4} mb={1}>
         {/* @ts-ignore  */}

            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddFaq;
